module.exports = __webpack_public_path__ + "static/S'24Instagram2-d3df34aa9efacb443d6fe2c937fef1fc.png";